// extracted by mini-css-extract-plugin
export var active = "repeater-item-module--active--43818";
export var spin = "repeater-item-module--spin--6966c";